module.exports = __webpack_public_path__ + "media/images/flags/rw-c58f3d8b73fcd4e1973b916ddc138aef.svg";